/**
 * Connection to frontal web
 */
import Ajax from '@/utils/ajax'
import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState([ 'site' ])
  },
  methods: {    
    ...mapActions(['setFatalError']),
    callAjax (url, data, post = true, excemptStatusCodeCheck = false, getSessionId = false) {
      this.notifToClient({ url: url, req: data })
      return Ajax[post ? 'post' : 'get'](url, data, getSessionId).then(rep => {
        this.notifToClient({ rep: rep })

        this.treatErrors(rep, excemptStatusCodeCheck)

        let response = {
          status: rep.status, 
          content: (rep.responseText && rep.contentType === 'application/json') ? JSON.parse(rep.responseText) : rep.responseText
        }
        return response
      }).catch(err => {
        this.notifToClient({ rep: err })
        if (process.env.NODE_ENV === 'production') this.setFatalError({ description: this.$t('error_technical_error') })
        return {
          status: err.status,
          content: {
            statusCode: -1
          }
        }
      })
    },
    treatErrors (rep, excemptStatusCodeCheck) {
      if (rep && rep.status !== 200) {
        let message = ''
        switch (rep.status) {
          case 401:
            message = this.$t('error_session_timeout')
            break;          
          default:
            message = this.$t('error_technical_error')
            break;
        }
        if (message) this.setFatalError({ description: message })
      }

      let defaultCode = (process.env.NODE_ENV === 'production') ? '1' : '0'
      var statusCode = 0
      var transactionStatus = 0;
      try {
        statusCode = excemptStatusCodeCheck ? '0' : rep.responseText && rep.contentType === 'application/json' ? JSON.parse(rep.responseText).statusCode : defaultCode
        transactionStatus = rep.responseText && rep.contentType === 'application/json' ? JSON.parse(rep.responseText).transactionStatus : defaultCode
      }
      catch(e) {
        statusCode = -1 // Technical error        
      }
      
      if (statusCode !== '0') {
        let message = ''
        switch (statusCode) {
          case '1':
          case 1:
            message = this.$t('error_treatment')
            break; 
          case '2':
          case 2:
            message = this.$t('error_no_payment_method')
            break;          
          case '3':
          case 3:
            message = this.$t('error_transaction_refused')
            break;          
          case '4':
          case 4:
            message = this.$t('error_transaction_not_authorized')
            break;          
          case '5':
          case 5:
            message = this.$t('error_invalid_payment_info')
            break;                   
          default:
            message = this.$t('error_technical_error')
            break;
        }
        this.setFatalError({ description: message })
      }

      if (transactionStatus === '40' || transactionStatus === 'refused') this.setFatalError({ description: this.$t('error_transaction_refused') })
    },
    baseUrl () {
      return '/api/client/v1/site' + (this.site ? '/' + this.site : '')
    },
    callAuthentication (authCode) {
      const url = this.baseUrl() + '/authent'
      return this.callAjax(url, { code: authCode }, false, false, true)
    },
    callPaymentMethods () {
      const url = this.baseUrl() + '/list-payment-method'
      return this.callAjax(url, {}, false)
    },
    callStartPayment (data) {
      const url = this.baseUrl() + '/start-payment'
      return this.callAjax(url, data)
    },
    callPaymentResult (data) {
      const url = this.baseUrl() + '/payment-result'
      return this.callAjax(url, data, false)
    },
    callSuppressAlias (aliasId) {
      const url = this.baseUrl() + '/suppress-alias'
      return this.callAjax(url, { aliasId: aliasId } )
    },
    callSDDDisplayOptions (data) {
      const url = this.baseUrl() + '/display-options'
      return this.callAjax(url, data, true, true)
    },
    notifToClient (message) {
      if (this.origin) window.parent.postMessage(JSON.stringify(message), this.origin)
    }
  }
}
